export * from './DomainConfig';
